module.exports = __webpack_public_path__ + "static/media/signup-service-image.56eed6ce.jpg";